import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronRight, MessageSquare, Plus } from "lucide-react";
import { useGetAllSupportTickets, useGetSupportUnreadCount } from "../../query/supportQuery";
import SupportAvatar from "../../views/support/SupportAvatar";
import { hasAdminUnread } from "../../views/support/supportHelpers";

function MessageSkeleton() {
  return (
    <div className="side-card-row side-card-student-skel" aria-hidden="true">
      <span className="side-card-skel is-avatar" />
      <div className="side-card-copy">
        <span className="side-card-skel is-name" />
        <span className="side-card-skel is-meta" />
      </div>
    </div>
  );
}

function Messages() {
  const navigate = useNavigate();
  const { data, isLoading } = useGetAllSupportTickets({ page: "1", limit: "5" });
  const { data: unreadCount = 0 } = useGetSupportUnreadCount();
  const tickets = data?.docs || [];
  const totalTickets = data?.totalDocs ?? 0;

  return (
    <section className="side-card side-card-support">
      <div className="side-card-head">
        <div>
          <h2 className="side-card-title">
            Support
            {!isLoading && unreadCount > 0 ? (
              <span className="side-card-count is-alert">{unreadCount}</span>
            ) : null}
          </h2>
          <p className="side-card-sub">
            {isLoading
              ? "Loading..."
              : totalTickets === 0
                ? "Inbox is clear"
                : `${totalTickets.toLocaleString("en-US")} conversations`}
          </p>
        </div>
        <button
          type="button"
          className="side-card-add"
          aria-label="New message"
          onClick={() => navigate("/support")}
        >
          <Plus size={14} strokeWidth={2.4} />
        </button>
      </div>

      <div className={`side-card-list${!isLoading && tickets.length === 0 ? " is-empty" : ""}`}>
        {isLoading ? (
          <>
            <MessageSkeleton />
            <MessageSkeleton />
            <MessageSkeleton />
            <MessageSkeleton />
            <MessageSkeleton />
          </>
        ) : tickets.length === 0 ? (
          <div className="side-card-empty side-card-empty-support">
            <span className="side-card-empty-icon">
              <MessageSquare size={18} strokeWidth={1.7} />
            </span>
            <p className="side-card-empty-title">No messages yet</p>
            <p className="side-card-empty-text">Start a conversation with a teacher or parent.</p>
          </div>
        ) : (
          tickets.map((ticket) => {
            const unread = hasAdminUnread(ticket);
            return (
              <button
                key={ticket._id}
                type="button"
                className={`side-card-row side-card-support-row${unread ? " is-unread" : ""}`}
                onClick={() => navigate(`/support/${ticket._id}`)}
              >
                <div className="side-card-person">
                  <span className="side-card-support-avatar-wrap">
                    <SupportAvatar ticket={ticket} size={30} className="side-card-support-avatar" />
                    {unread ? <span className="side-card-support-unread" aria-label="Unread" /> : null}
                  </span>
                  <div className="side-card-support-copy">
                    <p className="side-card-name">{ticket.participantName}</p>
                    <p className="side-card-support-subject">{ticket.subject}</p>
                  </div>
                </div>
                <span className="side-card-row-arrow" aria-hidden="true">
                  <ChevronRight size={14} strokeWidth={2.2} />
                </span>
              </button>
            );
          })
        )}
      </div>

      <button type="button" className="side-card-footer" onClick={() => navigate("/support")}>
        Open inbox
        <ArrowRight size={13} strokeWidth={2.2} />
      </button>
    </section>
  );
}

export default Messages;
